exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".help-body[data-v-e2cd4384]{text-align:justify;white-space:pre-line}.help-box[data-v-e2cd4384]{transition:all .2s ease-in-out}.help-dialog[data-v-e2cd4384]{z-index:99999}", ""]);

// exports
